import script from "./basic-options.vue?vue&type=script&setup=true&lang=ts"
export * from "./basic-options.vue?vue&type=script&setup=true&lang=ts"

import "./basic-options.vue?vue&type=style&index=0&id=3b1b08c6&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b1b08c6"]])

export default __exports__